/* eslint-disable  */
export const timeSchedule = [
    {
        id: 1,
        title: '9am - 9:30am',
        timeHours: {
            startHour: 9,
            startMin: 0,
            endHour: 9,
            endMin: 30,
        },
    },
    {
        id: 2,
        title: '9:30am - 10:00am',
        timeHours: {
            startHour: 9,
            startMin: 30,
            endHour: 10,
            endMin: 0,
        },
    },
    {
        id: 3,
        title: '10:00am - 10:30am',
        timeHours: {
            startHour: 10,
            startMin: 0,
            endHour: 10,
            endMin: 30,
        },
    },
    {
        id: 4,
        title: '10:30am - 11:00am',
        timeHours: {
            startHour: 10,
            startMin: 30,
            endHour: 11,
            endMin: 0,
        },
    },
    {
        id: 5,
        title: '11:00am - 11:30am',
        timeHours: {
            startHour: 11,
            startMin: 0,
            endHour: 11,
            endMin: 30,
        },
    },
    {
        id: 6,
        title: '11:30am - 12:00pm',
        timeHours: {
            startHour: 11,
            startMin: 30,
            endHour: 12,
            endMin: 0,
        },
    },
    {
        id: 7,
        title: '12:00pm - 12:30pm',
        timeHours: {
            startHour: 12,
            startMin: 0,
            endHour: 12,
            endMin: 30,
        },
    },
    {
        id: 8,
        title: '12:30am - 1:00pm',
        timeHours: {
            startHour: 12,
            startMin: 30,
            endHour: 1,
            endMin: 0,
        },
    },
    {
        id: 9,
        title: '1:00pm - 1:30pm',
        timeHours: {
            startHour: 13,
            startMin: 0,
            endHour: 13,
            endMin: 30,
        },
    },
    {
        id: 10,
        title: '1:30pm - 2:00pm',
        timeHours: {
            startHour: 13,
            startMin: 30,
            endHour: 14,
            endMin: 0,
        },
    },
    {
        id: 11,
        title: '2:00pm - 2:30pm',
        timeHours: {
            startHour: 14,
            startMin: 0,
            endHour: 14,
            endMin: 30,
        },
    },
    {
        id: 12,
        title: '2:30pm - 3:00pm',
        timeHours: {
            startHour: 14,
            startMin: 30,
            endHour: 15,
            endMin: 0,
        },
    },
    {
        id: 13,
        title: '3:00pm - 3:30pm',
        timeHours: {
            startHour: 15,
            startMin: 0,
            endHour: 15,
            endMin: 30,
        },
    },
    {
        id: 14,
        title: '3:30pm - 4:00pm',
        timeHours: {
            startHour: 15,
            startMin: 30,
            endHour: 16,
            endMin: 0,
        },
    },
];
